import React, {useEffect, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import axios from "axios";
import config from "../../../config.js";
import CustomDataTable from "../CustomDataTable";
import $ from "jquery";
import {trans} from "../../utils";

const Costs = ({data,sendRequest,params}) => {
    const [currencies, setCurrencies ] = useState([]);
    const [workOrderCostTypes, setWorkOrderCostTypes ] = useState([]);

    useEffect(() => {
        axios(config.SystemUrl + `select/Currency`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
            }
        })
            .then(result => setCurrencies(result.data.data) );
    }, [])

    useEffect(() => {
        axios(config.SystemUrl + `select/WorkOrderCostType`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
            }
        })
            .then(result => setWorkOrderCostTypes(result.data.data) );
    }, [])
    const [cost, setCost] = useState({
        description:'',
        work_order_id:'',
        part:'',
        cost_type_id:'',
        quantity:'',
        currency_id:'',
        est_cost:'',
        actual_cost:'',
        comment:'',
    });
    const handleDescriptionChange = event =>{
        setCost({...cost,description: event.target.value} );
    }
    const handlePartChange = event =>{
        setCost({...cost,part: event.target.value} );
    }
    const handleCostTypeChange = event =>{
        setCost({...cost,cost_type_id: event.target.value} );
    }
    const handleQuantityChange = event =>{
        setCost({...cost,quantity: event.target.value} );
    }
    const handleEstCostChange = event =>{
        setCost({...cost,est_cost: event.target.value} );
    }
    const handleActualCostChange = event =>{
        setCost({...cost,actual_cost: event.target.value} );
        setNumber2(parseInt (event.target.value) + parseInt(data.total_actual_cost) );
    }
    const handleCommentChange = event =>{
        setCost({...cost,comment: event.target.value} );
    }
    const handleCurrencyChange = event =>{
        setCost({...cost,currency_id: event.target.value} );
    }
    const handleCostsForm = event =>
    {
        event.preventDefault();

        sendRequest(cost,"WorkOrderCost",function(){ window.location.reload(); },function (){
            $("#cost").DataTable().ajax.reload()
            setCost({
                description:'',
                work_order_id:'',
                part:'',
                cost_type_id:'',
                quantity:'',
                currency_id:'',
                est_cost:'',
                actual_cost:'',
                comment:'',
            })
        })
    }
    const [number1, setNumber1] = useState(0);
    const [number2, setNumber2] = useState(0);
    const [total, setTotal] = useState(number1 + number2);
    useEffect(()=>{
            setNumber1(data.total_actual_cost)
    },[data])

    const columns = [
        {data:"description",title:"Description"},
        {data:"part",title:"Part"},
        {data:"quantity",title:"Quantity"},
        {data:"cost_type.title",title:"Type Cost"},
        {data:"est_cost",title:"EST cost"},
        {data:"actual_cost",title:"ACT. Cost"},
        {data:"currency.title",title:"Currency"},
        {data:"comment",title:"Comment"},
        ];
    return(
       <>
           <div className="card-header cursor-pointer">
               <div className="card-title m-0">
                   <h3 className="fw-bolder m-0">{trans('Costs')}</h3>
               </div>
               { data.status_data  &&
               data.status_data.title_en == "Active" && (data.is_assignee || data.is_admin) &&
               <div className="d-flex my-4">
                   <button type="button" className="btn btn btn-light-primary waves-effect waves-light" data-toggle="modal" data-target="#CostModal">
                       <i className="bi bi-plus fs-3"></i> Add a new cost
                   </button>
               </div>
               }
           </div>
           <div className="modal fade" id="CostModal" tabIndex="-1" role="dialog"
                aria-labelledby="CostModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                   <div className="modal-content">
                       <div className="modal-header">
                           <h5 className="modal-title" id="exampleModalLabel">{trans('Add a new cost')}</h5>
                           <button type="button" className="close" data-dismiss="modal"
                                   aria-label="Close">
                               <span aria-hidden="true">&times;</span>
                           </button>
                       </div>
                       <form onSubmit={handleCostsForm} encType="multipart/form-data">
                           <div className="modal-body">
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Description')} * :</label>
                                   <input
                                       className="form-control"
                                       type="text" name="actions"  value={cost.description}
                                       onChange={handleDescriptionChange}
                                       autoFocus required />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Part')} #:</label>
                                   <input
                                       className="form-control"
                                       type="text" name="actions"  value={cost.part}
                                       onChange={handlePartChange}
                                       autoFocus />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="recipient-name"
                                          className="col-form-label">{trans('Currency')} *</label>
                                   <select className="form-select form-select-sm"
                                           aria-label=".form-select-sm example"
                                           type="text" name="currency"
                                           onChange={handleCurrencyChange}
                                           value={cost.currency_id}
                                           required
                                   >
                                       <option value=""  disabled>{trans('Select an option')}</option>
                                       {currencies && currencies.map(currency => (
                                           <option key={currency.id} value={currency.id} >{trans(currency.title)}</option>
                                       ))}
                                   </select>
                               </div>
                               <div className="form-group">
                                   <label htmlFor="recipient-name"
                                          className="col-form-label">{trans('Cost Type')}</label>
                                   <select className="form-select form-select-sm"
                                           aria-label=".form-select-sm example"
                                           type="text" name="currency"
                                           onChange={handleCostTypeChange}
                                           value={cost.cost_type_id}
                                   >
                                       <option value="" >{trans('Select an option')}</option>
                                       {workOrderCostTypes && workOrderCostTypes.map(cost_type => (
                                               <option key={cost_type.id} value={cost_type.id} >{trans(cost_type.title)}</option>
                                       ))}
                                   </select>
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Quantity')} *:</label>
                                   <input
                                       className="form-control"
                                       type="number" name="actions"  value={cost.quantity}
                                       onChange={handleQuantityChange}
                                       autoFocus required />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('EST Cost')} :</label>
                                   <input
                                       className="form-control"
                                       type="number" name="actions"  value={cost.est_cost}
                                       onChange={handleEstCostChange}
                                       autoFocus  step="0.001" />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Actual Cost / WO')} :</label>
                                   <input
                                       className="form-control"
                                       type="number" name="actions"  value={cost.actual_cost}
                                       onChange={handleActualCostChange}
                                       autoFocus required step="0.001" />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Total Actual Cost')} :</label>
                                   <input
                                       className="form-control"
                                       value={number2}
                                       disabled
                                   />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Comment')} :</label>
                                   <input
                                       className="form-control"
                                       type="text" name="actions"  value={cost.comment}
                                       onChange={handleCommentChange}
                                       autoFocus  />
                               </div>
                           </div>
                           <div className="modal-footer">
                               <button type="button" className="btn btn-secondary"
                                       data-dismiss="modal">{trans('Close')}
                               </button>
                               <button  className="btn btn-primary"  type="submit">{trans('Submit')}</button>
                           </div>
                       </form>
                   </div>
               </div>
           </div>
           <div className="card-body p-9">
               <CustomDataTable columns={columns} url={"WorkOrderCost?wo_id="+params.id+"&include=cost_type,currency"} table_id="cost" />

           </div>
        </>
    )

}
export default Costs
